"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@/i18n/navigation";
import { useT } from "@/lib/i18n";
import { useBetaPrefix } from "@/lib/api/prefix.client";
import { STATS_LINKS } from "./kinds";
export default function StatsLinks(t0) {
  const $ = _c(14);
  const {
    current
  } = t0;
  const t = useT();
  const bp = useBetaPrefix();
  let t1;
  if ($[0] !== t) {
    t1 = t("View other stats");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("View other stats");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="mr-1 text-[var(--text-muted)]">{t2}:</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== bp || $[7] !== current || $[8] !== t) {
    t4 = STATS_LINKS.map(l => <Link key={l.href} prefetch={false} href={`${bp}${l.href}`} className={`rounded-md border px-2.5 py-1 transition-colors ${l.href === current ? "border-[var(--accent-gold)] text-[var(--accent-gold)]" : "border-[var(--border-subtle)] bg-[var(--bg-card)] text-[var(--text-secondary)] hover:border-[var(--border-accent)] hover:text-[var(--text-primary)]"}`}>{t(l.label)}</Link>);
    $[6] = bp;
    $[7] = current;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t4) {
    t5 = <nav aria-label={t1} className="mb-4 flex flex-wrap items-center gap-1.5 text-xs">{t3}{t4}</nav>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}